import {createFileRoute} from '@tanstack/react-router'
import PricingPage from "../landing/PricingPage.tsx";

export const Route = createFileRoute('/pricing')({
    component: About,
})

function About() {
    return <PricingPage />
}
